import { EnvConfig } from './types'

export const testConfig: EnvConfig = {
  isDev: false,
  isProd: false,
  isTest: true,
}
